/* import __COLOCATED_TEMPLATE__ from './signup-places-autocomplete.hbs'; */
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import Component from '@glimmer/component';

/** @module */
class SignupPlacesAutoComplete extends Component {
  element = null;

  @tracked hasFocus = false;
  @tracked blurredByClick = false;

  get isActive() {
    return this.hasFocus || this.blurredByClick;
  }

  @action
  refCallback(element) {
    this.element = element;
  }

  /**
   *
   */
  @action
  handleFocus() {
    this.hasFocus = true;
    this.blurredByClick = false;
  }

  /**
   *
   */
  @action
  handleBlur() {
    this.hasFocus = false;

    if (!this.blurredByClick) {
      this.resetInput();
      this.args.onblur?.();
    }
  }

  @action
  handleClear() {
    this.args.onchange?.(null);
  }

  @action
  handleMouseDown() {
    this.blurredByClick = true;
  }

  @action
  handlePlaceChanged(place) {
    this.resetInput();

    if (place.geometry) {
      this.args.onchange?.(place);
    }

    if (this.blurredByClick) {
      this.blurredByClick = false;
      this.args.onblur?.();
    }
  }

  /**
   * @private
   */
  resetInput() {
    this.element.value = this.args.value || '';
  }
}

export default SignupPlacesAutoComplete;
